import {
  DoctorconsoleGrid,
  StyledButton,
  StyledModal,
  StyledSelectForHeader,
  StyledInputLabel,
  theme,
} from "../doctor-console/StyledComponents";
import { ThemeProvider } from "@mui/material/styles";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import UploadIcon from "@mui/icons-material/Upload";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import MedicationIcon from "@mui/icons-material/Medication";
import PlayCircleFilledWhiteIcon from "@mui/icons-material/PlayCircleFilledWhite";
import { Link, useHistory, useLocation } from "react-router-dom";
import {
  Box,
  Button,
  IconButton,
  Tooltip,
  MenuItem,
  FormControl,
} from "@mui/material";
import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import { CheckToken } from "../login/AccessToken";
import ConsentModal from "../../components/ConsentModal";
import ProgressBar from "../../assets/img/Loading.gif";
import Completed from "../../assets/img/Completed.png";
import Cancelled from "../../assets/img/Cancelled.jpg";
import { v4 as uuidv4 } from "uuid";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import "./Screen2.scss";
import WeekCalender from "./WeekCalender";
import MonthCalender from "./MonthCalender";
import DoctorCard from "../../components/DoctorCard/DoctorCard";
import CareContextModal from "./CareContextModal ";
import UploadFileModal from "./UploadFileModal";
import AccessibilityIcon from "@mui/icons-material/Accessibility";
import WellmessVitals from "./WellmessVitals";
// import { Modal as MuiModal } from "@material-ui/core";
import { Modal as MuiModal } from "@mui/material"; // v5
import { Grid, CardContent, Avatar, Typography, Card } from "@mui/material";
import { toast } from "react-toastify";
import showConfirmDialog from "../../components/ShowConfirmDialog/ShowConfirmDialog";
import { Socket } from "../../components/Socket";
import ConsentHistory from "../doctor-console/Modals/ConsentHistory";
import { BrandingContext } from "../../BrandingProvider";
import CreateAppointment from "./CreateAppointment";
import EditAppointment from "./EditAppointment";
import PrescriptionUploadModal from "../doctor-console/Utils/PrescriptionUploadModal";
import DepartmentDoctorSelectorModal from "./DepartmentDoctorSelectorModal";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import SidebarAppointment from "./SidebarAppointment";
import AppointmentListPanel from "./AppointmentListPanel";
import CalendarModal from "./CalendarModal";
import Icon from "../doctor-console/Utils/Icons";
import DoctorSlotsModal from "../hlthtek-admin-demo/DoctorScheduling/DoctorSlotsModal";
import { usePermissions } from "../login/PermissionContext";
import CustomDoctorScheduleModal from "../hlthtek-admin-demo/DoctorScheduling/CustomDoctorScheduleModal";

const REACT_APP_SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
const REACT_APP_SENDER_EMAIL = process.env.REACT_APP_SENDER_EMAIL;

function getTime(isoTimestamp) {
  // Extracting time from ISO 8601 UTC format (e.g., "2024-05-16T00:01:00Z")
  var timeParts = isoTimestamp.split("T")[1].split(":");
  var hours = parseInt(timeParts[0]);
  var minutes = parseInt(timeParts[1]);

  // Converting time to 12-hour format
  var am_pm = hours >= 12 ? "PM" : "AM";
  hours = (hours % 12 || 12).toString();
  if (hours.length === 1) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }

  return hours + ":" + minutes + " " + am_pm;
}
// const ws = new WebSocket(`${REACT_APP_SOCKET_URL}`);
const randomId = uuidv4();

function Appointments() {
  const [openCalendarModal, setOpenCalendarModal] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const [patientDataDict, setPatientDataList] = useState({});
  const [totalAppointments, setTotalAppointments] = useState(0);
  const [cancelledAppointments, setCancelledAppointments] = useState(0);
  const [todaysAppointments, setTodaysAppointments] = useState(0);
  const [selectedPatientDataDict, setSelectedPatientDataDict] = useState([]);
  const [reports, setReports] = useState([]);
  const [getConsent, setGetConsent] = useState({});
  const [doctorAppointmentList, setDoctorAppointmentList] = useState([]);
  const [loadingAppointments, setLoadingAppointments] = useState(false);
  const [fhirArrData, setFhirArrData] = useState([]);
  const [careContexts, setCareContexts] = useState([]);
  const [openSettingModal, setOpenSettingModal] = useState(false);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const [isAiEnabled, setIsAiEnabled] = useState(
    sessionStorage.getItem("isAiEnabled") !== undefined &&
      sessionStorage.getItem("isAiEnabled") !== null
      ? JSON.parse(sessionStorage.getItem("isAiEnabled"))
      : false
  );
  const [isLoading, setIsLoading] = useState(false);
  const [oldDataFound, setOldDataFound] = useState(false);
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  var [fetchRequestId, setFetchRequestId] = useState(null);
  var [fetchStatus, setFetchStatus] = useState({});
  var [prescriptionList, setPrescriptionList] = useState([]);
  const [currentPatientData, setCurrentPatientData] = useState([]);
  var [FHIRData, setFHIRData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  var [finalStatus, setFinalStatus] = useState("");
  const [rowSelected, setRowSelected] = useState("");
  const [fetchOldRecords, setFetchOldRecords] = useState(false);
  const [careContextArr, setCareContextArr] = useState([]);
  const [isFetchingLastRec, setIsFetchingLastRec] = useState(false);
  const [patientObj, setPatientObj] = useState([]);
  const [rawFhir, setRawFhir] = useState({});
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const REACT_APP_HIU = process.env.REACT_APP_HIU;
  const REACT_APP_REQUESTER_NAME = process.env.REACT_APP_REQUESTER_NAME;
  const REACT_APP_IDENTIFIER_TYPE = process.env.REACT_APP_IDENTIFIER_TYPE;
  const REACT_APP_IDENTIFIER_VALUE = process.env.REACT_APP_IDENTIFIER_VALUE;
  const REACT_APP_IDENTIFIER_SYSTEM = process.env.REACT_APP_IDENTIFIER_SYSTEM;
  const [patientList, setPatientList] = useState([]);
  const [doctorsList, setDoctorsList] = useState([]);
  const [todaysCancelledAppointments, setTodaysCancelledAppointments] =
    useState(0);
  const [todaysPendingAppointments, setTodaysPendingAppointments] = useState(0);
  const [isContextModalOpen, setIsContextModalOpen] = useState(false);
  const [isVitalModalOpen, setIsVitalModalOpen] = useState(false);
  const [vitalName, setVitalName] = useState();
  const [vitalPatientId, setVitalPatientId] = useState();
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [abhaId, setAbhaId] = useState([]);
  const [doctorCurrentId, setDoctorCurrentId] = useState();
  const [finalDoctorId, setFinalDoctorId] = useState();
  const [roleType, setRoleType] = useState("");
  const [requestIds, setRequestIds] = useState([]);
  const [fetchedCareContexts, setFetchedCareContexts] = useState([]);
  const [requestIdDetails, setRequestIdDetails] = useState([]);
  const [dateForAppointment, setDateForAppointment] = useState(new Date());
  const roleTypeUser = sessionStorage.getItem("roleType");
  const [facilityDoctorList, setFacilityDoctorList] = useState([]);
  const [consentHistoryModalOpen, setConsentHistoryModalOpen] = useState(false);
  const facilityId = sessionStorage.getItem("facility_name");
  const [patients, setPatients] = useState([]);
  const [selectedPatId, setselectedPatId] = useState(null);
  const [selectedEmailId, setselectedEmailId] = useState(null);
  // Visit type selection driven by `get_patient_appointment_type/`
  // FIRST_VISIT / FOLLOW_UP / REPORT_VISIT + parent appointment id rules.
  const [initialVisitType, setInitialVisitType] = useState("FIRST_VISIT");
  const [parentAppointmentIdFromApi, setParentAppointmentIdFromApi] = useState(
    null
  );
  const [isNewVisitLocked, setIsNewVisitLocked] = useState(false);
  const [isAppointmentTypeLoading, setIsAppointmentTypeLoading] = useState(false);
  const [reloadCalendar, setReloadCalendar] = useState(false);
  const [todaysCompletedAppointments, setTodaysCompletedAppointments] =
    useState(0);
  const [selectedPatientforModal, setSelectedPatientforModal] = useState();
  const [appointmentModal, setAppointmentModal] = useState(false);
  const [completedAppointments, setCompletedAppointments] = useState([]);
  const [cancelledAppointmentsList, setCancelledAppointmentsList] = useState(
    []
  );
  const [pendingAppointments, setPendingAppointments] = useState([]);
  const [onlineAppointments, setOnlineAppointments] = useState([]);
  const [offlineAppointments, setOfflineAppointments] = useState([]);
  const [appointmentFlag, setAppointmentFlag] = useState("total");
  const [hoveredButton, setHoveredButton] = useState(null);

  const brandingData = useContext(BrandingContext);
  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    getValues: getValues2,
    setValue: setValue2,
    watch: watch2,
    reset: reset2,
  } = useForm();
  const searchType = watch2("searchType");
  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  const {
    register,
    formState: { errors },
    getValues,
    watch,
    setValue,
    handleSubmit,
    reset,
  } = useForm();
  const {
    register: editRegister,
    formState: { errors: editErrors },
    getValues: editGetValues,
    watch: editWatch,
    setValue: editSetValue,
    handleSubmit: editHandleSubmit,
  } = useForm();

  const [isPatientOpen, setIsPatientOpen] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [editingAppointmentId, setEditingAppointmentId] = useState(null);
  const [reschedulePatientId, setReschedulePatientId] = useState(null);
  const [rescheduleAppointmentType, setRescheduleAppointmentType] =
    useState(null);
  const [reschedulePatientDisplayName, setReschedulePatientDisplayName] =
    useState("");
  const [rescheduleSlotNumber, setRescheduleSlotNumber] = useState(null);
  const [rescheduleSlotStartTime, setRescheduleSlotStartTime] = useState(null);
  const [rescheduleSlotEndTime, setRescheduleSlotEndTime] = useState(null);
  const [isAbdmEnabled, setIsAbdmEnabled] = useState(false);
  const [selectedDoctorData, setSelectedDoctorData] = useState(false);
  const [openPrescriptionUploadModal, setOpenPrescriptionUploadModal] =
    useState(false);
  const [handwrittenFiles, setHandwrittenFiles] = useState([]);
  const [appointmentIndex, setAppointmentIndex] = useState("");
  // const doctorId = location.state?.doctorId;
  const [selectedDoctorId, setSelectedDoctorId] = useState(null);
  // const [selectedDepartmentId, setSelectedDepartmentId] = useState(null);
  const [appointDataTotal, setAppointDataTotal] = useState(null);
  const [openSlotsModal, setOpenSlotsModal] = useState(false);
  const doctorId = selectedDoctorId;

  console.log("Doctor ID:", doctorId);
  const [isDepartmentDoctorModalOpen, setIsDepartmentDoctorModalOpen] =
    useState(false);

  const { userInfo } = usePermissions();

  const isFirstRender = useRef(true); //to track if DOM is rendered for first time

  const handleOpenSettings = () => {
    setOpenSettingModal(true);
  };

  const handleCancelSettings = () => {
    setOpenSettingModal(false);
  };

  const handleOpenSlots = () => {
    setOpenSlotsModal(true);
  };

  const handleCancelSlots = () => {
    // setUserIdForSettings(null);
    setOpenSlotsModal(false);
    setEditingAppointmentId(null);
    setReschedulePatientId(null);
    setRescheduleAppointmentType(null);
    setReschedulePatientDisplayName("");
    setRescheduleSlotNumber(null);
    setRescheduleSlotStartTime(null);
    setRescheduleSlotEndTime(null);
  };

  const handleClosePrescriptionUploadModal = () => {
    setOpenPrescriptionUploadModal(false);
  };
  const handleOpenPrescriptionUploadModal = (i) => {
    setOpenPrescriptionUploadModal(true);
    setAppointmentIndex(i);
  };

  const handleSubmitHandwrittenPrescription = async (files) => {
    if (files.length === 0) {
      toast.error("Please upload a prescription before submitting.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("file", files[0]); // only one file allowed

      // Example: call backend API
      const response = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}add_hw_prescription/`,
        formData,
        {
          headers: headers,
        }
      );
      if (response?.data?.status === "Success") {
        history.push({
          pathname: `/doctor/QuickConsultation`,
          state: {
            patientData:
              patientDataDict[doctorAppointmentList[appointmentIndex].patient],
            reports: FHIRData,
            fhirArrData: fhirArrData,
            prescriptionList: prescriptionList,
            doctorData: selectedDoctorData,
            appointmentId:
              doctorAppointmentList[appointmentIndex].appointment_id,
            sectionsData: response?.data?.data,
            dateForAppointment: dateForAppointment,
            startTime: doctorAppointmentList[appointmentIndex].start_time,
          },
        });
      } else {
        toast.error("Prescription upload unsuccessful!");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to upload prescription.");
    }
  };
  useEffect(() => {
    if (sessionStorage.getItem("roleType") == "facility user") {
      setIsDepartmentDoctorModalOpen(true);
    } else {
      console.log("doctor");
      setSelectedDoctorId(sessionStorage.getItem("doctor_id"));
      // setSelectedDepartmentId(userInfo.department_id);
    }
  }, []);

  // Auto-populate appointment times when modal opens from department selection
  useEffect(() => {
    if (appointmentModal && !isPatientOpen) {
      handleShow();
    }
  }, [appointmentModal, isPatientOpen]);
  const handleShow = () => {
    const now = new Date();

    // Adjust to IST (UTC +5:30)
    const offsetIST = 5.5 * 60 * 60 * 1000; // 5 hours 30 minutes in milliseconds
    const nowIST = new Date(now.getTime() + offsetIST);
    // const currentDateTimeIST = nowIST.toISOString().slice(0, 16); // Format to match input[type="datetime-local"]

    const startIST = new Date(nowIST.getTime() + 5 * 60 * 1000);
    const currentDateTimeIST = startIST.toISOString().slice(0, 16);

    const oneHourLaterIST = new Date(nowIST.getTime() + 25 * 60 * 1000);
    const endDateTimeIST = oneHourLaterIST.toISOString().slice(0, 16);

    setValue("appointment_start_time", currentDateTimeIST);
    setValue("appointment_end_time", endDateTimeIST);

    setIsPatientOpen(true);
  };
  useEffect(() => {
    const storedRoleType = sessionStorage.getItem("roleType");
    if (storedRoleType) {
      setRoleType(storedRoleType);
    }
  }, []);
  useEffect(() => {
    console.log(
      "Fhir Arr Data Changed",
      JSON.parse(JSON.stringify(fhirArrData))
    );
  }, [fhirArrData]);

  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);
  // const doctor_id = sessionStorage.getItem("doctor_id");

  const handlePreviousDate = () => {
    const newDate = new Date(dateForAppointment);
    newDate.setDate(newDate.getDate() - 1);
    setDateForAppointment(newDate);
  };

  const handleNextDate = () => {
    const newDate = new Date(dateForAppointment);
    newDate.setDate(newDate.getDate() + 1);
    setDateForAppointment(newDate);
  };

  const formatDate = (date) => {
    const options = { day: "numeric", month: "long", year: "numeric" };
    return new Date(date).toLocaleDateString("en-GB", options);
  };

  useEffect(() => {
    const doctorData = doctorsList.find(
      (doctor) => doctor.doctor_id === selectedDoctorId
    );

    if (doctorData) {
      setSelectedDoctorData(doctorData);
    }
  }, [finalDoctorId, doctorsList, selectedDoctorId]);
  console.log("selectedDoctorData///", selectedDoctorData);
  console.log("finalDoctorId///", finalDoctorId);

  useEffect(() => {
    const isAbdmEnabledFromSession = sessionStorage.getItem("isAbdmEnabled");

    if (isAbdmEnabledFromSession) {
      setIsAbdmEnabled(JSON.parse(isAbdmEnabledFromSession));
    }
  }, []);
  const handleClose = () => {
    reset2();
    setPatients([]);
    setselectedPatId(null);
    setInitialVisitType("FIRST_VISIT");
    setParentAppointmentIdFromApi(null);
    setIsNewVisitLocked(false);
    setIsAppointmentTypeLoading(false);
    setIsPatientOpen(false);
    reset();
    setselectedEmailId(null);
    setAppointmentModal(false);
  };
  const appointmentSubmit = (data, e, opts) => {
    console.log(data);
    console.log("testing..");
    e.preventDefault();
    console.log(data, "data..");
    // const newData = {
    //   ...data,
    //   new_patient: false,
    // };

    const doctorId = sessionStorage.getItem("doctor_id");
    const isDoctor = roleType === "doctor";
    console.log(typeof roleType);

    console.log(doctorId, isDoctor);
    const newData = {
      ...data,
      new_patient: false,
      ...(isDoctor && { doctor_id: doctorId }),
      patient_id: selectedPatId,
      status: "SCHEDULED",
    };

    // Ensure backend contract for first visit:
    // FIRST_VISIT must always send `parent_appointment_id: null`.
    if (newData.appointment_type === "FIRST_VISIT") {
      newData.parent_appointment_id = null;
    }

    console.log(newData, "newdata");
    if (newData.patient_id) {
      const startDate = new Date(newData.appointment_start_time);
      const endDate = new Date(newData.appointment_end_time);

      const isSameDay =
        startDate.getFullYear() === endDate.getFullYear() &&
        startDate.getMonth() === endDate.getMonth() &&
        startDate.getDate() === endDate.getDate();

      if (!isSameDay) {
        toast.error("Start and end time must be on the same day");
        return;
      }

      if (endDate <= startDate) {
        toast.error("End time must be after start time");
        return;
      }

      return axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}add_appointment/`,
          JSON.stringify(newData),
          { headers: headers }
        )
        .then((response) => {
          if (response.data.status === "Success") {
            fetchDoctorAppointmentDetails();
            setReloadCalendar((prev) => !prev);
            console.log(response);
            sendEmail(newData);
            toast.success("Appointment scheduled successfully");
            if (!opts || !opts.skipClose) {
              handleClose();
            }
            return response.data;
          } else {
            toast.error(response.data.message);
            return response.data;
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          return { status: "Error", message: "Unexpected error" };
        });

      if (!opts || !opts.skipClose) {
        handleClose();
      }
    } else {
      toast.error("Please select patient");
      return { status: "Error", message: "Patient not selected" };
    }
  };

  const sendEmail = (data) => {
    try {
      console.log("Preparing to send email...");
      let bannerBase64 = null;

      const bannerObject = brandingData.find(
        (item) => item.name === "email_banner" && item.type === "image"
      );

      if (bannerObject) {
        bannerBase64 = bannerObject.content; // Get the base64 content
      } else {
        console.error("Banner image not found in branding data");
        toast.error("Failed to find the banner image.");
        return;
      }
      // Extract date and time separately from start_time and end_time
      const startDateTime = new Date(data.appointment_start_time);
      const endDateTime = new Date(data.appointment_end_time);
      const appointmentDate = startDateTime.toISOString().split("T")[0];
      const startTime = startDateTime.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }); // Extract time
      const endTime = endDateTime.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }); // Extract time

      // Combine start and end time
      const appointmentTime = `${startTime} - ${endTime}`;

      const emailData = {
        SENDER: REACT_APP_SENDER_EMAIL,
        SUBJECT: "New Appointment Created Successfully",
        RECIPIENT: selectedEmailId,
        patient_id: selectedPatId,
        appointment_date: appointmentDate,
        appointment_time: appointmentTime,
        doctor_id: data.doctor_id,
        facility_id: facilityId,
        TYPE: "APPOINTMENT",
        BANNER: bannerBase64,
      };

      console.log("Sending...", emailData);

      if (sessionStorage.getItem("isEmailEnabled") !== "true") {
        toast.error("Email service not activated for this license");
      } else if (
        !selectedEmailId ||
        typeof selectedEmailId !== "string" ||
        selectedEmailId.trim() === ""
      ) {
        toast.error("Email not sent as patient's email address is unavailable");
      } else {
        axios
          .post(
            `${process.env.REACT_APP_BACKEND_ROUTE_URL}send_email/`,
            emailData,
            {
              headers: {
                Authorization: `Bearer ${authToken}`,
              },
            }
          )
          .then((response) => {
            if (response.data.Status === "completed") {
              console.log("Email sent successfully", response.data);
              toast.success("Email sent successfully.");
            } else {
              toast.error("Email not sent");
            }
          })
          .catch((error) => {
            console.error("Error sending email", error);
            toast.error("Error sending email. Please try again.");
          });
      }
    } catch (error) {
      console.error("Error preparing email data", error);
      toast.error(
        "Error preparing email data. Please check the details and try again."
      );
    }
  };

  const openModal = (patientData, row) => {
    console.log("Patient Data from appointment page open Modal", patientData);

    setIsModalOpen(true);
    setRowSelected(row);
    var patientDataArr = [];
    patientDataArr.push(patientData);
    setCurrentPatientData(patientDataArr);
    fetchFilteredCareContextList(patientData?.patient_id);
    console.log(patientDataDict[patientData?.patient_id]);
    setSelectedPatientDataDict(patientDataDict[patientData?.patient_id]);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsFetchingLastRec(false);
    setOldDataFound(false);
    setPatientObj([]);
    setCurrentPatientData([]);
    setSelectedPatientDataDict([]);
    setCareContextArr([]);
    setRowSelected("");
  };

  const closeOnSubmit = () => {
    setIsModalOpen(false);
  };
  function formatDateTime(inputDateString) {
    // console.log("Input string", inputDateString);
    const originalDate = new Date(inputDateString);
    const istOffset = 5.5 * 60 * 60 * 1000;
    originalDate.setTime(originalDate.getTime() + istOffset);

    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
      timeZoneName: "short",
    };
    console.log("Original date", originalDate.toLocaleString("en-IN", options));
    return originalDate.toLocaleString("en-IN", options);
  }
  function handleGetPatientData(patientData, row) {
    if (!isAbdmEnabled) {
      toast.error("Facility is not abdm enabled!");
      return;
    }
    var patient_abha_id = patientDataDict[patientData?.patient_id]?.abha_id;
    if (patient_abha_id == "" || patient_abha_id === null) {
      toast.error("No Abha Address Present");
      return;
    }
    setIsFetchingLastRec(true);
    setFinalStatus("");
    console.log("Patient data from handleGetPatient", patientData);
    //fetchFilteredCareContextList(patientData?.patient_id)
    //selectPatient(patientData?.patient_id, row)

    console.log("Patient abha id from handleGetPatient", patient_abha_id);
    var patientReportData = [];
    axios
      .get(
        `${REACT_APP_BACKEND_ROUTE_URL}get_data_transfer_consent_list/?patientAbhaID=` +
        patient_abha_id,
        {
          headers: headers,
          params: { status: false },
        }
      )
      .then(async (res) => {
        if (res.data?.data.length > 0) {
          patientReportData = res.data?.data;
          console.log("Patient Report Data", patientReportData);
          var lastData = [];
          for (var i = patientReportData.length; i >= 0; i--) {
            if (patientReportData[i]?.data_received_details?.length > 0) {
              var fhirFound = 0;
              var consentDetails = patientReportData[i]?.consent_details;
              var dataReceivedDetailsArr =
                patientReportData[i]?.data_received_details;
              dataReceivedDetailsArr.map((dataObj) => {
                var fhirListArr = dataObj?.fhir_list;
                if (
                  fhirListArr?.length > 0 &&
                  dataObj?.status === "DATA RECEIVED"
                ) {
                  fhirFound = fhirFound + 1;
                  lastData.push(consentDetails);
                  console.log("Index no", i);
                  console.log("Details", patientReportData[i]);
                }
              });
              if (fhirFound == 1) {
                setIsFetchingLastRec(false);
                break;
              }
            }
          }
          if (lastData.length > 0) {
            setIsFetchingLastRec(false);
            const message = `Patient data was last fetched at ${formatDateTime(
              lastData[0]?.data_received_at
            )}, do you want to continue and create the consent request again?`;
            const confirmed = await showConfirmDialog(message);
            if (confirmed) {
              openModal(patientData, row);
            }
          } else {
            setIsFetchingLastRec(false);
            const message =
              "No data found in the previous consent request, do you want to go ahead and create a new consent instead?";
            const confirmed = await showConfirmDialog(message);
            if (confirmed) {
              openModal(patientData, row);
            }
          }
        } else {
          setIsFetchingLastRec(false);
          const message =
            "No previous consent request found, do you want to create a new consent instead?";
          const confirmed = await showConfirmDialog(message);
          if (confirmed) {
            openModal(patientData, row);
          }
        }
      })
      .catch((err) => {
        setIsFetchingLastRec(false);
        console.log(err);
        toast.error(err);
      });
  }
  const handleDataReceived = (i) => {
    console.log("Handle Data Received Function Called", i);
    history.push({
      pathname: `/doctor/DoctorConsole`,
      state: {
        patientData: {
          ...patientDataDict[doctorAppointmentList[i].patient],
          appointment_type: doctorAppointmentList[i].appointment_type,
        },
        reports: FHIRData,
        fhirArrData: fhirArrData,
        prescriptionList: prescriptionList,
        doctorData: selectedDoctorData,
        appointmentId: doctorAppointmentList[i].appointment_id,
        startTime: doctorAppointmentList[i].start_time,
        dateForAppointment: dateForAppointment,
      },
    });
  };

  function fetchPatientDetails() {
    if (Token()) {
      var patientData = [];
      axios
        .get(
          `${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_with_aabha_info/`,
          {
            headers: headers,
          }
        )
        .then((response) => {
          console.log("Patient Data Response", response);
          for (var i = 0; i < response.data?.data.length; i++) {
            patientData[response.data?.data[i].patient_id] =
              response.data?.data[i];
          }
          setPatientDataList(patientData);
          setPatientList(response.data?.data);
        })
        .catch((error) => {
          console.log("FETCH FAILED");
          console.log(error);
        });
    }
  }
  function fetchFacilityDoctors() {
    if (Token()) {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_facility_specific_doctors/`, {
          headers: headers,
        })
        .then((response) => {
          console.log("facility specific dr", response);
          if (response.data.status == "Success") {
            setFacilityDoctorList(response.data.doctor_list);
          } else {
            console.log("error");
          }
        })
        .catch((error) => {
          console.log("FETCH FAILED");
          console.log(error);
        });
    }
  }
  console.log(doctorCurrentId);

  function fetchDoctors() {
    if (Token()) {
      let apiUrl = "";

      if (roleTypeUser === "doctor") {
        apiUrl = `${REACT_APP_BACKEND_ROUTE_URL}get_all_doctors/`;
      } else {
        apiUrl = `${REACT_APP_BACKEND_ROUTE_URL}get_doctors_based_on_facility_user/`;
      }

      axios
        .get(apiUrl, {
          headers: headers,
        })
        .then((response) => {
          if (response.data.status === "Success") {
            setDoctorsList(response.data?.data);
          }
          // const doctorL = response.data
          // setDoctorCurrentId(doctorL[0].doctor_id)
        })
        .catch((error) => {
          console.log("FETCH FAILED");
          console.log(error);
        });
    }
  }

  // console.log(doctorsList)
  function getSessionDoctorId() {
    return sessionStorage.getItem("doctor_id");
  }
  function isUserDoctor() {
    return sessionStorage.getItem("roleType");
  }

  // function fetchDoctorAppointmentDetails() {
  //   let idToSend;
  //   if (isUserDoctor() == "doctor") {
  //     idToSend = getSessionDoctorId();
  //   } else {
  //     idToSend = doctorId;
  //   }
  //   // if (!idToSend) {
  //   //   console.log("Doctor ID is invalid.");
  //   //   return;
  //   // }
  //   setFinalDoctorId(idToSend);
  //   if (Token() && idToSend) {
  //     setLoadingAppointments(true);
  //     console.log("test", idToSend);

  //     const year = dateForAppointment.getFullYear();
  //     const month = String(dateForAppointment.getMonth() + 1).padStart(2, "0"); // Adding 1 as months are zero-based
  //     const day = String(dateForAppointment.getDate()).padStart(2, "0");

  //     const formattedDate = `${year}-${month}-${day}`;

  //     axios
  //       .post(
  //         `${REACT_APP_BACKEND_ROUTE_URL}get_doctor_appointments/`,
  //         { id: idToSend, date: formattedDate },
  //         {
  //           headers: headers,
  //         }
  //       )
  //       .then((response) => {
  //         setLoadingAppointments(false);
  //         // console.log("Appointments "+response.data.appointments);
  //         // response.data.appointments.map((i) => {
  //         //   console.log(i);
  //         // });
  //         setAppointDataTotal(response.data);
  //         setDoctorAppointmentList(response.data.appointments);
  //         setTotalAppointments(response.data.total_appointments);
  //         setCancelledAppointments(response.data.cancelled_appointments);
  //         setTodaysAppointments(response.data.todays_total_appointments);
  //         setTodaysCancelledAppointments(
  //           response.data.todays_cancelled_appointments
  //         );
  //         setTodaysPendingAppointments(
  //           response.data.todays_pending_appointments
  //         );
  //         setTodaysCompletedAppointments(
  //           response.data.todays_completed_appointments
  //         );
  //       })
  //       .catch((error) => {
  //         setLoadingAppointments(false);
  //         console.log("FETCH FAILED");
  //         console.log(error);
  //       });
  //   } else {
  //     console.log("no id found");
  //   }
  // }

  function fetchDoctorAppointmentDetails() {
    let idToSend;
    if (isUserDoctor() == "doctor") {
      idToSend = getSessionDoctorId();
    } else {
      idToSend = doctorId;
    }
    // if (!idToSend) {
    //   console.log("Doctor ID is invalid.");
    //   return;
    // }
    setFinalDoctorId(idToSend);
    if (Token() && idToSend) {
      setLoadingAppointments(true);
      console.log("test", idToSend);

      const year = dateForAppointment.getFullYear();
      const month = String(dateForAppointment.getMonth() + 1).padStart(2, "0"); // Adding 1 as months are zero-based
      const day = String(dateForAppointment.getDate()).padStart(2, "0");

      const formattedDate = `${year}-${month}-${day}`;

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_doctor_appointments/`,
          { id: idToSend, date: formattedDate },
          {
            headers: headers,
          }
        )
        .then((response) => {
          console.log("response in fetch", response.data.status);
          console.log("appointments in fetch", response.data.appointments);
          if (
            response.data.status === "Success" &&
            response.data.appointments.length > 0
          ) {
            console.log("hereif---------");
            setLoadingAppointments(false);

            const appointments = response.data.appointments;
            // Sort appointments by start_time_ist in ascending order
            appointments.sort(
              (a, b) => new Date(a.start_time_ist) - new Date(b.start_time_ist)
            );
            setDoctorAppointmentList(appointments);
            setTotalAppointments(response.data.total_appointments);
            setCancelledAppointments(response.data.cancelled_appointments);
            setTodaysAppointments(response.data.todays_total_appointments);
            setTodaysCancelledAppointments(
              response.data.todays_cancelled_appointments
            );
            setTodaysPendingAppointments(
              response.data.todays_pending_appointments
            );
            setTodaysCompletedAppointments(
              response.data.todays_completed_appointments
            );

            // Classify appointments
            const completedAppointments = appointments.filter(
              (appointment) => appointment.status === "COMPLETED"
            );
            const cancelledAppointments = appointments.filter(
              (appointment) => appointment.status === "CANCELLED"
            );
            const scheduledAppointments = appointments.filter(
              (appointment) => appointment.status === "SCHEDULED"
            );
            const onlineAppointments = appointments.filter(
              (appointment) => appointment.appointment_mode === "ONLINE"
            );
            const offlineAppointments = appointments.filter(
              (appointment) => appointment.appointment_mode === "OFFLINE"
            );

            // Set state for each category
            setCompletedAppointments(completedAppointments);
            setCancelledAppointmentsList(cancelledAppointments);
            setPendingAppointments(scheduledAppointments);
            setOnlineAppointments(onlineAppointments);
            setOfflineAppointments(offlineAppointments);
          } else {
            console.log("here else---------");
            setLoadingAppointments(false);
            setDoctorAppointmentList([]);
          }
        })
        .catch((error) => {
          setLoadingAppointments(false);
          console.log("FETCH FAILED");
          console.log(error);
        });
    } else {
      console.log("no id found");
    }
  }

  console.log("appointments", doctorAppointmentList);

  function fetchFilteredCareContextList(patient_id) {
    var data = {
      patient_reference_id: patient_id,
      patient_name: patientDataDict[patient_id].name,
    };
    axios
      .post(`${REACT_APP_BACKEND_ROUTE_URL}fetch_contexts_record/`, data, {
        headers: headers,
      })
      .then((res) => {
        console.log(res.data);
        if (res.data?.data.length > 0) {
          setCareContextArr(res.data?.data);
          console.log("care context arr", res.data?.data);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(err);
      });
  }

  function selectPatient(patient_id, selectPatientRow) {
    setFinalStatus("");
    var patient_abha_id = patientDataDict[patient_id].abha_id;
    console.log("Select Patient Abha Id", patient_abha_id);
    if (patient_abha_id == "" || patient_abha_id === null) {
      toast.error("No Abha Address Present");
      return;
    }
    const patientData = patientDataDict[patient_id];
    setFetchOldRecords(true);
    setSelectedPatientDataDict(patientDataDict[patient_id]);
    setPatientObj(patientData);
    setIsLoading(true);
    if (Token()) {
      fetchFilteredCareContextList(patient_id);
      axios
        .get(
          `${REACT_APP_BACKEND_ROUTE_URL}get_data_transfer_consent_list/?patientAbhaID=` +
          patient_abha_id,
          {
            headers: headers,
            params: { status: false },
          }
        )
        .then(async (res) => {
          if (res.data?.data.length > 0) {
            console.log("Old reports", res.data?.data);
            setIsLoading(false);
            // console.log("Old reports",)
            setReports(res.data?.data);
          } else {
            setOldDataFound(false);
            const message =
              "No previous record found, do you want to go ahead and create a consent instead?";
            const confirmed = await showConfirmDialog(message);
            if (confirmed) {
              openModal(patientData, selectPatientRow);
              setFetchOldRecords(false);
              setSelectedPatientDataDict([]);
            } else {
              // console.log("Redirecttttttttttttttttttttttttttt");
              console.log(doctorAppointmentList[selectPatientRow]);

              history.push("/doctor/DoctorConsole", {
                patientData: {
                  ...patientDataDict[
                    doctorAppointmentList[selectPatientRow].patient
                  ],
                  appointment_type:
                    doctorAppointmentList[selectPatientRow].appointment_type,
                },
                reports: FHIRData,
                fhirArrData: null,
                prescriptionList: prescriptionList,
                doctorData: selectedDoctorData,
                appointmentId:
                  doctorAppointmentList[selectPatientRow].appointment_id,
                startTime: doctorAppointmentList[selectPatientRow].start_time,
                dateForAppointment: dateForAppointment,
              });
            }
            setIsLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
      setRowSelected(selectPatientRow);
    }
  }
  const organizeDataByCareContext = (data, hipId) => {
    const mainArray = [];
    data.forEach((item, iterationIndex) => {
      const { contextReference } = item;
      //find if carecontext already present or not
      const alreadyFound = mainArray.find(
        (entry) => entry.careContextReference === contextReference
      );

      let composition = item.content.find((entry) =>
        entry.hasOwnProperty("Composition")
      );
      console.log("Composition in useeffect", composition);

      let compositionSnomedCode = null;
      let key = "Display not found";

      if (composition) {
        compositionSnomedCode = composition?.Composition?.code?.[0]?.code;

        switch (compositionSnomedCode) {
          case "440545006":
            key = "Prescription";
            break;
          case "721981007":
            key = "Diagnostic Report";
            break;
          case "371530004":
            key = "OP Consultation";
            break;
          case "373942005":
            key = "Discharge Summary";
            break;
          case "41000179103":
            key = "Immunization Record";
            break;
          case "419891008":
            key = "Record artifact";
            break;
          case "1156871006":
            key = "Wellness Record";
            break;
        }
      }

      const compositionDate = composition?.Composition?.date?.split("T")[0];
      console.log("Snomed and hi type", compositionSnomedCode, key);

      if (alreadyFound) {
        //if care context already present then finding its index
        const index = mainArray.findIndex(
          (entry) => entry.careContextReference === contextReference
        );
        //in that particular index see if the date is already present or not
        const dateEntry = mainArray[index]["fhir_data"].find(
          (item) => item[compositionDate]
        );

        if (dateEntry) {
          //if date is already present then push the new hitype and its data to the date array
          dateEntry[compositionDate].push({ [key]: item.content });
        } else {
          //if date is not present then push a new obj to the mainArray of that carecontext index with date as its key and hi type and its resources as its value
          mainArray[index].fhir_data.push({
            [compositionDate]: [{ [key]: item.content }],
          });
        }
      } else {
        // if care context is not presnet then push a new obj to the main array with date as its key and hi type and its resources as its value
        const organizedData = {
          fhir_data: [{ [compositionDate]: [{ [key]: item.content }] }],
          careContextReference: contextReference,
          hipId: hipId,
        };
        mainArray.push(organizedData);
      }
    });

    return mainArray;
  };
  useEffect(() => {
    console.log(
      "Useeffect called ",
      reports.length,
      careContextArr.length,
      patientObj.length,
      rowSelected
    );
    if (reports.length > 0 && rowSelected !== "") {
      let fhirFound = 0; // Initialize fhirFound flag outside the loop
      for (let i = reports.length - 1; i >= 0; i--) {
        // Start the loop from reports.length - 1
        console.log("indexxxx", i);
        if (fhirFound === 1) {
          // Check if fhirFound is already 1
          break; // Break the loop if fhirFound is already 1
        }
        if (reports[i]?.data_received_details?.length > 0) {
          console.log("Reports Data", reports[i]);
          const dataReceivedDetailsArr = reports[i].data_received_details;
          console.log("data received details", dataReceivedDetailsArr);
          for (let k = 0; k < dataReceivedDetailsArr.length; k++) {
            const fhirListArr = dataReceivedDetailsArr[k]?.fhir_list;
            console.log("fhir list arr", fhirListArr);
            if (
              fhirListArr?.length > 0 &&
              dataReceivedDetailsArr[k]?.status == "DATA RECEIVED"
            ) {
              fhirFound = fhirFound + 1;

              let updatedData = [];
              dataReceivedDetailsArr.forEach((data) => {
                let newData = organizeDataByCareContext(
                  data.fhir_list,
                  data.hip_id
                );
                updatedData = updatedData.concat(newData);
              });
              console.log("Fhir Data From Reports UseEffect", updatedData);
              console.log("Fhir Found", fhirFound === 1);
              if (fhirFound === 1) {
                setOldDataFound(true);
                setFhirArrData(updatedData);
                setIsLoading(false);
                history.push("/doctor/DoctorConsole", {
                  patientData: {
                    ...patientDataDict[
                      doctorAppointmentList[rowSelected].patient
                    ],
                    appointment_type:
                      doctorAppointmentList[rowSelected].appointment_type,
                  },
                  reports: FHIRData,
                  fhirArrData: updatedData,
                  prescriptionList: prescriptionList,
                  doctorData: selectedDoctorData,
                  appointmentId:
                    doctorAppointmentList[rowSelected].appointment_id,
                  startTime: doctorAppointmentList[rowSelected].start_time,
                  dateForAppointment: dateForAppointment,
                });
                break; // Break both inner and outer loops
              }
            }
          }
        }
      }
      if (fhirFound === 0) {
        setIsLoading(false);
        setOldDataFound(false);
        setFetchOldRecords(false);
        setSelectedPatientDataDict([]);
      }
    }
  }, [reports]);

  useEffect(async () => {
    if (
      !isLoading &&
      !oldDataFound &&
      patientObj.length !== 0 &&
      rowSelected !== "" &&
      fhirArrData.length == 0 &&
      !fetchOldRecords &&
      selectedPatientDataDict.length === 0
    ) {
      const message =
        "No previous records found, do you want to create a consent first?";
      const confirmed = await showConfirmDialog(message);
      if (confirmed) {
        openModal(patientObj, rowSelected);
      } else {
        console.log(doctorAppointmentList[rowSelected]);

        history.push("/doctor/DoctorConsole", {
          patientData: {
            ...patientDataDict[doctorAppointmentList[rowSelected].patient],
            appointment_type:
              doctorAppointmentList[rowSelected].appointment_type,
          },
          reports: FHIRData,
          fhirArrData: null,
          prescriptionList: prescriptionList,
          doctorData: selectedDoctorData,
          appointmentId: doctorAppointmentList[rowSelected].appointment_id,
          startTime: doctorAppointmentList[rowSelected].start_time,
          dateForAppointment: dateForAppointment,
        });
      }
    }
  }, [oldDataFound, fetchOldRecords]);

  useEffect(() => {
    if (authToken !== "") {
      fetchPatientDetails();
      fetchDoctors();
      fetchFacilityDoctors();

      // Call fetchDoctorAppointmentDetails only on first render
      if (isFirstRender.current) {
        fetchDoctorAppointmentDetails();
      }
    }
  }, [authToken, selectedDoctorId]);

  useEffect(() => {
    if (!isFirstRender.current) {
      fetchDoctorAppointmentDetails();
    }
    isFirstRender.current = false; // Mark first render as done after first useEffect runs
  }, [doctorCurrentId, dateForAppointment, selectedDoctorId]);

  console.log("Main organized Array", fhirArrData);
  console.log("Care context fetched", fetchedCareContexts);

  console.log("doctorAppointmentList", doctorAppointmentList);
  console.log("New Fhir Array Data", fhirArrData);

  async function checkFetchStatus(requestId) {
    if (Token()) {
      const ws = Socket("1234", requestId);
      ws.onopen = () => {
        console.log("WebSocket Connected");
        // var randomId = uuidv4();
        // ws.send(
        //   JSON.stringify({
        //     id: randomId,
        //   })
        // );
      };

      ws.onclose = () => {
        console.log("Websocket Closed!");
      };
    }
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const getPatientDataConsent = (abha_id, data) => {
    setIsLoading(true);
    setGetConsent(false);
    console.log("Get Patient Data", abha_id);
    console.log(data.purpose);
    setTimeout(() => {
      setGetConsent(true);
    }, 1 * 60 * 1000);
    // }, 30 * 60 * 1000)
    if (Token()) {
      if (data.length > 0) {
        axios
          .post(
            `${REACT_APP_BACKEND_ROUTE_URL}gateway/create_consent_request_init/`,
            {
              consent: {
                purpose: {
                  text: "string",
                  code: data[0].purpose,
                },
                patient: {
                  id: abha_id,
                },
                hiu: {
                  id: REACT_APP_HIU,
                },
                requester: {
                  name: selectedDoctorData.name,
                  // identifier: {
                  //   type: REACT_APP_IDENTIFIER_TYPE,
                  //   value: REACT_APP_IDENTIFIER_VALUE,
                  //   system: REACT_APP_IDENTIFIER_SYSTEM,
                  // },
                },
                hiTypes: data[0].infoTypes.map((infoType) =>
                  infoType.replace(" ", "")
                ),
                permission: {
                  accessMode: "VIEW",
                  dateRange: {
                    from: data[0].from,
                    to: data[0].to,
                  },
                  dataEraseAt: data[0].expiry,
                  frequency: {
                    unit: "HOUR",
                    value: 1,
                    repeats: 0,
                  },
                },
              },
            },
            {
              headers: headers,
            }
          )
          .then(async (response) => {
            if (response.data.request_id) {
              var c = 0;
              console.log("GOT THIS RESPONSE");
              console.log("GOT THIS RESPONSE", response.data);
              console.log("GOT THIS RESPONSE MESSAGE", response.data.message);
              // setFinalStatus(
              //   "Health Information Consent Created. Awaiting Patient Approval ..."
              // );
              toast.success(
                "Consent request submitted. Please wait a moment to view the consent history."
              );
              setFetchRequestId(response.data.request_id);
              fetchRequestId = response.data.request_id;
              checkFetchStatus(response.data.request_id);
            } else {
              toast.error(response.data.message);
            }
          })
          .catch((error) => {
            console.log("FETCH FAILED");
            console.log(error);
            toast.error(error);
            setCurrentPatientData([]);
            setIsFetchingLastRec(false);
            setOldDataFound(false);
            setPatientObj([]);
            setSelectedPatientDataDict([]);
            setRowSelected("");
          });
      }
    }
  };

  const handleContextModalOpen = (abhaId, patient) => {
    console.log("patient", patient);
    setSelectedPatientforModal(patient);
    setAbhaId(abhaId);
    setIsContextModalOpen(true);
  };

  const handleContextModalClose = () => {
    setIsContextModalOpen(false);
    setAbhaId("");
  };
  const handleVitalModalOpen = (appointmentId, patientId) => {
    console.log("vitalmodal should open");
    setVitalName(patientId);
    setVitalPatientId(appointmentId);
    setIsVitalModalOpen(true);
  };

  const handleVitalModalClose = () => {
    setIsVitalModalOpen(false);
    setVitalName("");
  };
  console.log(isVitalModalOpen, "isVitalModalOpen");

  const handleConsentModalOpen = (patientData) => {
    console.log("Handle Consent Modal Open", patientData);
    if (!isAbdmEnabled) {
      toast.error("Facility is not abdm enabled!");
      return;
    }
    if (patientData.abha_id == "" || patientData.abha_id === null) {
      toast.error("No Abha Address Present");
      return;
    }
    let patientDataArr = [];
    patientDataArr.push(patientData);
    setCurrentPatientData(patientDataArr);
    setConsentHistoryModalOpen(true);
  };
  const handleConsentModalClose = () => {
    setConsentHistoryModalOpen(false);
  };

  const handleUploadModalOpen = (abhaId, patientId) => {
    // if (!isAbdmEnabled) {
    //   toast.error("Facility is not abdm enabled!");
    //   return;
    // }
    setAbhaId(abhaId || ""); // Allow empty abhaId for non-ABHA users
    setSelectedPatientforModal(patientId); // Store patientId for local upload
    setIsUploadModalOpen(true);
  };

  const handleUploadtModalClose = () => {
    setIsUploadModalOpen(false);
    setAbhaId("");
  };

  const handleWellnessModalOpen = (abhaId) => { };

  const handleWellnessModalClose = () => { };

  const consentNotFound = () => {
    toast.error("Consent doesn't exist!");
  };
  // console.log(
  //   rowSelected,
  //   fhirArrData.length,
  //   isLoading,
  //   finalStatus,
  //   currentPatientData.length
  // );
  const [view, setView] = useState("day"); // 'day', 'week', 'month'

  const handleViewChange = (newView) => {
    setView(newView);
  };

  // const handleCancelAppointment = async (appointmentId) => {
  //   const message = "Are you sure you want to cancel this appointment?";
  //   const confirmed = await showConfirmDialog(message);

  //   if (confirmed) {
  //     var data = {
  //       appointment_id: appointmentId,
  //       status: "CANCELLED",
  //       remarks: null,
  //     };
  //     axios
  //       .post(`${REACT_APP_BACKEND_ROUTE_URL}update_appointment/`, data, {
  //         headers: headers,
  //       })
  //       .then((res) => {
  //         fetchDoctorAppointmentDetails();
  //         toast.success("Appointment Cancelled Successfully!");
  //         console.log(res.data);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //         toast.error(err);
  //       });
  //   }
  // };
  const handleCancelAppointment = async (appointmentId) => {
    const message = "Are you sure you want to cancel this appointment?";
    const confirmed = await showConfirmDialog(message);

    if (confirmed) {
      const data = {
        appointment_id: appointmentId,
        status: "CANCELLED",
        remarks: null,
      };

      try {
        const res = await axios.post(
          `${REACT_APP_BACKEND_ROUTE_URL}update_appointment/`,
          data,
          { headers }
        );

        await fetchDoctorAppointmentDetails();
        toast.success("Appointment Cancelled Successfully!");
        console.log(res.data);
      } catch (err) {
        console.log(err);
        toast.error("Failed to cancel appointment");
        throw err;
      }
    }
  };

  const handleCompletedAppointment = async (appointmentId) => {
    const message =
      "Are you sure you want to mark this appointment as complete?";
    const confirmed = await showConfirmDialog(message);
    if (confirmed) {
      var data = {
        appointment_id: appointmentId,
        status: "COMPLETED",
        remarks: null,
      };
      axios
        .post(`${REACT_APP_BACKEND_ROUTE_URL}update_appointment/`, data, {
          headers: headers,
        })
        .then((res) => {
          fetchDoctorAppointmentDetails();
          console.log(res.data);
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    }
  };

  const handleDoctorChange = (doctor_id) => {
    setDoctorCurrentId(doctor_id);
  };
  // const handleGoBack = () => {
  //   history.push('/doctor/appointmentsCards');
  // };
  const handleGoBack = () => {
    const roleType = sessionStorage.getItem("roleType");

    if (roleType === "doctor") {
      history.push("/doctor/landing");
    } else if (roleType === "user" || roleType === "facility user") {
      history.push("/doctor/appointmentsCards");
    }
    // You can add a default redirect here if needed
  };
  const convertToDateTimeLocalFormat = (isoDateTime) => {
    const date = new Date(isoDateTime);

    // Decrease time by 5 hours and 30 minutes

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const handleEditButtonClick = (appointment) => {
    console.log("Appointment", appointment);
    // setOpenEditModal(true);
    setEditingAppointmentId(appointment.appointment_id);
    setReschedulePatientId(appointment.patient ?? null);
    setRescheduleAppointmentType(appointment.appointment_type ?? null);
    setReschedulePatientDisplayName(
      patientDataDict[appointment.patient]?.name ??
      appointment.patient_name ??
      ""
    );
    setRescheduleSlotNumber(appointment.slot_number ?? null);
    const toHHmmFromIso = (iso) => {
      if (iso == null || iso === "") return null;
      const m = String(iso).match(/T(\d{2}):(\d{2})/);
      return m ? `${m[1]}:${m[2]}` : null;
    };
    setRescheduleSlotStartTime(
      toHHmmFromIso(appointment.start_time_ist || appointment.start_time)
    );
    setRescheduleSlotEndTime(
      toHHmmFromIso(appointment.end_time_ist || appointment.end_time)
    );
    setOpenSlotsModal(true);
    // console.log(
    //   " convertToDateTimeLocalFormat(appointment.start_time_ist)",
    //   convertToDateTimeLocalFormat(appointment.start_time)
    // );
    // editSetValue(
    //   "appointment_start_time",
    //   convertToDateTimeLocalFormat(appointment.start_time_ist)
    // );
    // editSetValue(
    //   "appointment_end_time",
    //   convertToDateTimeLocalFormat(appointment.end_time_ist)
    // );
    // editSetValue("doctor_id", doctorId);
  };
  const handleCloseEditModal = () => {
    setOpenEditModal(false);
  };
  console.log(
    "Final Status and Row Selected",
    finalStatus,
    rowSelected,
    isFetchingLastRec
  );

  const editAppointmentSubmit = (data, e) => {
    console.log("inside edit", data);
    const requestData = {
      ...data,
      appointment_id: editingAppointmentId,
    };
    if (!requestData.appointment_type) {
      requestData.appointment_type = "FIRST_VISIT";
    }
    if (requestData.appointment_type === "FIRST_VISIT") {
      requestData.parent_appointment_id = null;
    }
    console.log("inside edit", requestData);

    const startDate = new Date(requestData.appointment_start_time);
    const endDate = new Date(requestData.appointment_end_time);

    const isSameDay =
      startDate.getFullYear() === endDate.getFullYear() &&
      startDate.getMonth() === endDate.getMonth() &&
      startDate.getDate() === endDate.getDate();

    if (!isSameDay) {
      toast.error("Start and end time must be on the same day");
      return;
    }

    if (endDate <= startDate) {
      toast.error("End time must be after start time");
      return;
    }

    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}edit_appointment/`,
        JSON.stringify(requestData),
        {
          headers: headers,
        }
      )
      .then((response) => {
        if (response.data.status == "Success") {
          fetchDoctorAppointmentDetails();
          setReloadCalendar((prev) => !prev);
          handleCloseEditModal();
          setEditingAppointmentId(null);
        } else {
          toast.error(response.data.message);
        }

        console.log(response);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const formatAbhaNumber = (abhaNumber) => {
    return abhaNumber.replace(/(\d{2})(\d{4})(\d{4})(\d{4})/, "$1-$2-$3-$4");
  };
  const onSubmitSearch = (data) => {
    console.log(data);

    let filterCriteria;

    switch (data.searchType) {
      case "abhaId":
        filterCriteria = {
          filter_type: "abha_id",
          filter_details: {
            abha_id: data.searchQuery,
          },
          multipleResults: true,
        };
        break;
      case "abhaNo":
        const formattedAbhaNumber = formatAbhaNumber(data.searchQuery);
        filterCriteria = {
          filter_type: "abha_number",
          filter_details: {
            abha_number: formattedAbhaNumber,
          },
          multipleResults: true,
        };
        break;
      case "phoneNo":
        filterCriteria = {
          filter_type: "phone_number",
          filter_details: {
            phone_number: data.searchQuery,
          },
          multipleResults: true,
        };
        break;
      case "demographics":
        filterCriteria = {
          filter_type: "demographics",
          filter_details: {
            name: data.name,
            gender: data.gender,
            dob: data.dob,
          },
          multipleResults: true,
        };
        break;
      default:
        console.log("Invalid search type");
        return;
    }

    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}get_filtered_patient_data/`,
        filterCriteria,
        {
          headers: headers,
        }
      )
      .then((response) => {
        console.log(response.data);
        if (response.data.status === "Success") {
          toast.success("Patient Found Successfully");
          setPatients(response.data.patient_details);
          // setPatientData(response.data.patient_details);
        } else if (response.data.status === "Failed") {
          toast.error(response.data.message);
          setPatients([]);
          setPatients(null);
        } else {
          toast.error("Error");
        }
      })
      .catch((error) => {
        console.log("FETCH FAILED");

        console.log(error);
      });
  };
  const handleCardSelect = (patId, selectedDateForAppointment = null) => {
    setselectedPatId(patId);
    setIsAppointmentTypeLoading(true);
    const appointmentDate = selectedDateForAppointment || dateForAppointment;
    const year = appointmentDate.getFullYear();
    const month = String(appointmentDate.getMonth() + 1).padStart(2, "0");
    const day = String(appointmentDate.getDate()).padStart(2, "0");
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_ROUTE_URL}get_patient_appointment_type/`,
        { doctor_id: doctorId, patient_id: patId, appointment_date: `${year}-${month}-${day}` },
        { headers: headers }
      )
      .then((response) => {
        if (response.data.status === "Success") {
          const followupVisit = !!response.data?.data?.followup_visit;
          const parentId =
            response.data?.data?.parent_appointment_id ?? null;

          // Rules (from requirements):
          // 1) followup_visit=false & parent_appointment_id=null => New Visit locked
          // 2) followup_visit=false & parent_appointment_id!=null => New Visit, other types allowed
          // 3) followup_visit=true => Follow up selected, other types allowed
          if (!followupVisit && parentId === null) {
            setInitialVisitType("FIRST_VISIT");
            setParentAppointmentIdFromApi(null);
            setIsNewVisitLocked(true);
          } else if (!followupVisit && parentId !== null) {
            setInitialVisitType("FIRST_VISIT");
            setParentAppointmentIdFromApi(parentId);
            setIsNewVisitLocked(false);
          } else if (followupVisit) {
            setInitialVisitType("FOLLOW_UP");
            setParentAppointmentIdFromApi(parentId);
            setIsNewVisitLocked(false);
          } else {
            // Fallback to keep the UI usable.
            setInitialVisitType("FIRST_VISIT");
            setParentAppointmentIdFromApi(parentId);
            setIsNewVisitLocked(false);
          }
        } else {
          console.log("Appointment type", response.data);
          setInitialVisitType("FIRST_VISIT");
          setParentAppointmentIdFromApi(null);
          setIsNewVisitLocked(false);
        }
      })
      .catch((error) => {
        console.error("Error receing appointment type", error);
        setInitialVisitType("FIRST_VISIT");
        setParentAppointmentIdFromApi(null);
        setIsNewVisitLocked(false);
      })
      .finally(() => {
        setIsAppointmentTypeLoading(false);
      });
  };

  return (
    <ThemeProvider theme={theme}>
      {/* <DepartmentDoctorSelectorModal
        open={isDepartmentDoctorModalOpen}
        handleClose={() => setIsDepartmentDoctorModalOpen(false)}
         onDoctorSelect(doctor.doctor_id);
      /> */}

      {isDepartmentDoctorModalOpen && (
        <DepartmentDoctorSelectorModal
          // setAppointmentModal={setAppointmentModal}
          // onClose={() => setIsDepartmentDoctorModalOpen(false)}
          // onDoctorSelect={(selectedDoctorId) => {
          //   console.log("Selected doctor ID:", selectedDoctorId);
          //   setSelectedDoctorId(selectedDoctorId);
          // }}
          // selectedDoctorId={selectedDoctorId}
          // setAppointmentModal={setAppointmentModal}
          setOpenSlotsModal={setOpenSlotsModal}
          open={isDepartmentDoctorModalOpen}
          handleClose={() => setIsDepartmentDoctorModalOpen(false)}
          onDoctorSelect={(selectedDoctorId) => {
            // console.log("Selected doctor ID:", selectedDoctorId, departmentId);
            setSelectedDoctorId(selectedDoctorId);
            // setSelectedDepartmentId(departmentId.department_id);
            // You can store it in state or call another function
          }}
          selectedDoctorId={selectedDoctorId}
        />
      )}

      <DoctorSlotsModal
        open={openSlotsModal}
        onClose={handleCancelSlots}
        doctorId={doctorId}
        // departmentId={selectedDepartmentId}
        setValue={setValue}
        //for create appointment
        isPatientOpen={isPatientOpen}
        handleClose={handleClose}
        handleSubmit2={handleSubmit2}
        onSubmitSearch={onSubmitSearch}
        setselectedEmailId={setselectedEmailId}
        register2={register2}
        searchType={searchType}
        patients={patients}
        selectedPatId={selectedPatId}
        handleCardSelect={handleCardSelect}
        handleSubmit={handleSubmit}
        appointmentSubmit={appointmentSubmit}
        register={register}
        // doctorId={doctorId}
        doctorsList={doctorsList}
        errors={errors}
        roleType={roleType}
        appointmentModal={appointmentModal}
        fetchDoctorAppointmentDetails={fetchDoctorAppointmentDetails}
        setReloadCalendar={setReloadCalendar}
        sendEmail={sendEmail}
        handleCancelAppointment={handleCancelAppointment}
        // departmentId={selectedDepartmentId}
        initialRescheduleData={
          editingAppointmentId
            ? {
              appointment_id: editingAppointmentId,
              patient_id: reschedulePatientId,
              appointment_type: rescheduleAppointmentType,
              patient_name: reschedulePatientDisplayName || null,
              slot_number: rescheduleSlotNumber,
              slot_start_time: rescheduleSlotStartTime,
              slot_end_time: rescheduleSlotEndTime,
            }
            : null
        }
        initialVisitType={initialVisitType}
        parentAppointmentIdFromApi={parentAppointmentIdFromApi}
        isNewVisitLocked={isNewVisitLocked}
        isAppointmentTypeLoading={isAppointmentTypeLoading}
      />

      {/* <Card
        sx={{
          p: 3, // padding inside (all sides)
          pt: 4, // extra padding top
          pb: 4, // extra padding bottom
          // marginTop: "10%",
          boxShadow: 3,
          bgcolor: "white",
        }}
      >
        <Grid container spacing={2}>
       
          <Grid item xs={12} sm={5} md={4}>
            <SidebarAppointment
              handleShow={handleShow}
              setIsDepartmentDoctorModalOpen={setIsDepartmentDoctorModalOpen}
              appointDataTotal={appointDataTotal}
              setOpenAppointmentListModal={setOpenAppointmentListModal}
            />
          </Grid>

        
          <Grid item xs={12} sm={7} md={8}>
            <Grid container direction="column" spacing={2}>
            
              <Grid item>
                <DoctorCard
                  doctorData={selectedDoctorData}
                  doctorCurrentId={doctorCurrentId}
                />
              </Grid>

            
              <Grid item>
                <WeekCalender id={doctorId} date={dateForAppointment} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Card> */}

      <Card
        sx={{
          p: 3,
          // pt: 4,
          pb: 4,
          // boxShadow: 3,
          bgcolor: "white",
        }}
      >
        <Grid container spacing={2}>
          {/* <Grid item xs={12}>
            <DoctorCard
              doctorData={selectedDoctorData}
              doctorCurrentId={doctorCurrentId}
            />
          </Grid> */}

          {/* Top action row: 4 items */}
          <Grid item xs={12}>
            <Box
              sx={{
                display: "grid",
                gap: 2,
                gridTemplateColumns: {
                  xs: "1fr",
                  sm: "repeat(2, 1fr)",
                  md: "repeat(4, 1fr)",
                },
                gridAutoRows: { xs: "auto", sm: "auto", md: "48px" },
              }}
            >
              {/* 1: Add Appointment */}
              <Button
                fullWidth
                variant="contained"
                startIcon={<Icon name="bnewappointment" size={20} />}
                // onClick={handleShow}
                onClick={handleOpenSlots}
                disabled={!doctorId}
                sx={{
                  backgroundColor: "#0E3F66",
                  color: "#fff",
                  textTransform: "none",
                  fontSize: "14px",
                  fontWeight: 600,
                  borderRadius: "10px",
                  boxShadow: "none",
                  opacity: doctorId ? 1 : 0.65,
                  cursor: doctorId ? "pointer" : "not-allowed",
                  "&.Mui-disabled": {
                    opacity: 0.65,
                    backgroundColor: "#0E3F66",
                    color: "#fff",
                    cursor: "not-allowed",
                    pointerEvents: "auto",
                  },
                  "&:hover": { boxShadow: "none" },
                }}
              >
                Add Appointment
              </Button>

              {/* 2: Appointment Calendar */}
              <Button
                fullWidth
                variant="contained"
                startIcon={<Icon name="bappointmentcalender" size={20} />}
                onClick={() => setOpenCalendarModal(true)}
                disabled={!doctorId}
                sx={{
                  backgroundColor: "#0E3F66",
                  color: "#fff",
                  textTransform: "none",
                  fontSize: "14px",
                  fontWeight: 600,
                  borderRadius: "10px",
                  boxShadow: "none",
                  opacity: doctorId ? 1 : 0.65,
                  cursor: doctorId ? "pointer" : "not-allowed",
                  "&.Mui-disabled": {
                    opacity: 0.65,
                    backgroundColor: "#0E3F66",
                    color: "#fff",
                    cursor: "not-allowed",
                    pointerEvents: "auto",
                  },
                  "&:hover": { boxShadow: "none" },
                }}
              >
                Appointment Calendar
              </Button>

              {/* 3: Doctor's Schedule */}
              <Button
                fullWidth
                onClick={handleOpenSettings}
                disabled={!doctorId}
                variant="contained"
                startIcon={<Icon name="bdoctorSchedule" size={24} />}
                sx={{
                  backgroundColor: "#0E3F66",
                  color: "#fff",
                  textTransform: "none",
                  fontSize: "14px",
                  fontWeight: 600,
                  borderRadius: "10px",
                  boxShadow: "none",
                  opacity: doctorId ? 1 : 0.65,
                  cursor: doctorId ? "pointer" : "not-allowed",
                  "&.Mui-disabled": {
                    opacity: 0.65,
                    backgroundColor: "#0E3F66",
                    color: "#fff",
                    cursor: "not-allowed",
                    pointerEvents: "auto",
                  },
                  "&:hover": { boxShadow: "none" },
                }}
              >
                Doctor's Schedule
              </Button>

              {/* 4: Filter dropdown - use StyledSelectForHeader for consistent styling */}
              <FormControl fullWidth>
                {/* <StyledInputLabel id="filter-view-label">Filter View</StyledInputLabel> */}
                <StyledSelectForHeader
                  labelId="filter-view-label"
                  id="filter-view"
                  value={appointmentFlag}
                  label="Filter View"
                  onChange={(e) => setAppointmentFlag(e.target.value)}
                  native={false}
                  sx={{
                    backgroundColor: "#0E3F66",
                    borderRadius: "10px",
                    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                    "& .MuiInputBase-input": {
                      color: "#fff",
                      fontWeight: 600,
                      py: 0,
                      lineHeight: 1,
                    },
                    "& .MuiOutlinedInput-root": { height: { xs: 40, md: 48 } },
                    "& .MuiSelect-select": {
                      display: "flex",
                      alignItems: "center",
                      minHeight: 0,
                      paddingTop: 0,
                      paddingBottom: 0,
                      height: "100%",
                      pl: 1.5,
                    },
                    "& .MuiSelect-icon": { color: "#fff" },
                    height: { xs: 40, md: 48 },
                  }}
                >
                  <MenuItem value="total">All</MenuItem>
                  <MenuItem value="offline">F-2-F</MenuItem>
                  <MenuItem value="online">Online</MenuItem>
                  <MenuItem value="completed">Completed</MenuItem>
                  <MenuItem value="pending">Pending</MenuItem>
                  <MenuItem value="canceled">Canceled</MenuItem>
                </StyledSelectForHeader>
              </FormControl>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <AppointmentListPanel
              appointmentFlag={appointmentFlag}
              setDateForAppointment={setDateForAppointment}
              dateForAppointment={dateForAppointment}
              view={view}
              doctorAppointmentList={doctorAppointmentList}
              loadingAppointments={loadingAppointments}
              patientDataDict={patientDataDict}
              selectedDoctorData={selectedDoctorData}
              // handlers
              getTime={getTime}
              handleEditButtonClick={handleEditButtonClick}
              handleCancelAppointment={handleCancelAppointment}
              handleCompletedAppointment={handleCompletedAppointment}
              handleContextModalOpen={handleContextModalOpen}
              handleUploadModalOpen={handleUploadModalOpen}
              handleVitalModalOpen={handleVitalModalOpen}
              handleGetPatientData={handleGetPatientData}
              handleConsentModalOpen={handleConsentModalOpen}
              handleOpenPrescriptionUploadModal={
                handleOpenPrescriptionUploadModal
              }
              handleDataReceived={handleDataReceived}
              selectPatient={selectPatient}
              showConfirmDialog={showConfirmDialog}
              onPaymentModalClose={fetchDoctorAppointmentDetails}
              // vars
              roleTypeUser={roleTypeUser}
              roleType={roleType}
              isAbdmEnabled={isAbdmEnabled}
              isAiEnabled={isAiEnabled}
              FHIRData={FHIRData}
              fhirArrData={fhirArrData}
              prescriptionList={prescriptionList}
              finalStatus={finalStatus}
              rowSelected={rowSelected}
              currentPatientData={currentPatientData}
              isLoading={isLoading}
              history={history}
              Cancelled={Cancelled}
              Completed={Completed}
              ProgressBar={ProgressBar}
              completedAppointments={completedAppointments}
              cancelledAppointmentsList={cancelledAppointmentsList}
              pendingAppointments={pendingAppointments}
              onlineAppointments={onlineAppointments}
              offlineAppointments={offlineAppointments}
            />
          </Grid>
        </Grid>
      </Card>

      {/* <DoctorconsoleGrid style={{ marginTop: "3%" }}>
        <Grid container spacing={2} >
       
          <Grid item xs={12} sm={5} md={4}>
            <SidebarAppointment
              handleShow={handleShow}
              setIsDepartmentDoctorModalOpen={setIsDepartmentDoctorModalOpen}
              appointDataTotal={appointDataTotal}
              setOpenAppointmentListModal={setOpenAppointmentListModal}
            />
          </Grid>

         
          <Grid item xs={12} sm={7} md={8}>
            <Grid container direction="column" spacing={2}>
             
              <Grid item>
                <DoctorCard
                  doctorData={selectedDoctorData}
                  doctorCurrentId={doctorCurrentId}
                />
              </Grid>

            
              <Grid item>
                <WeekCalender id={doctorId} date={dateForAppointment} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DoctorconsoleGrid> */}

      <CalendarModal
        open={openCalendarModal}
        onClose={() => setOpenCalendarModal(false)}
        doctorId={doctorId}
        dateForAppointment={dateForAppointment}
        reload={reloadCalendar}
        view={view === "month" ? "month" : "week"}
      />

      <PrescriptionUploadModal
        open={openPrescriptionUploadModal}
        handleClose={handleClosePrescriptionUploadModal}
        handleSubmitAdd={handleSubmitHandwrittenPrescription}
        files={handwrittenFiles}
        setFiles={setHandwrittenFiles}
        patientId={
          appointmentIndex !== "" && doctorAppointmentList[appointmentIndex]
            ? doctorAppointmentList[appointmentIndex].patient
            : undefined
        }
        authToken={authToken}
        facilityName={sessionStorage.getItem("facility_name") || ""}
        backendUrl={REACT_APP_BACKEND_ROUTE_URL}
      />

      <ConsentHistory
        open={consentHistoryModalOpen}
        handleClose={handleConsentModalClose}
        patientData={currentPatientData[0]}
      />

      <StyledModal
        open={isVitalModalOpen}
        handleClose={handleVitalModalClose}
        style={{ overflowY: "auto" }}
        title="Add New Vitals/Wellness"
      >
        <div className="modal-container">
          <WellmessVitals
            patientDetails={patientDataDict[vitalName]}
            patientId={vitalName}
            appointmentId={vitalPatientId}
            handleClose={handleVitalModalClose}
          />
        </div>
      </StyledModal>

      <CreateAppointment
        isPatientOpen={isPatientOpen}
        handleClose={handleClose}
        handleSubmit2={handleSubmit2}
        onSubmitSearch={onSubmitSearch}
        setselectedEmailId={setselectedEmailId}
        register2={register2}
        searchType={searchType}
        patients={patients}
        selectedPatId={selectedPatId}
        handleCardSelect={handleCardSelect}
        handleSubmit={handleSubmit}
        appointmentSubmit={appointmentSubmit}
        register={register}
        doctorId={doctorId}
        doctorsList={doctorsList}
        errors={errors}
        roleType={roleType}
        appointmentModal={appointmentModal}
        onPaymentModalClose={fetchDoctorAppointmentDetails}
        initialVisitType={initialVisitType}
        parentAppointmentIdFromApi={parentAppointmentIdFromApi}
        isNewVisitLocked={isNewVisitLocked}
        isAppointmentTypeLoading={isAppointmentTypeLoading}
      // departmentId={selectedDepartmentId}
      />
      <CustomDoctorScheduleModal
        open={openSettingModal}
        handleClose={handleCancelSettings}
        doctorId={doctorId}
      />
      <EditAppointment
        openEditModal={openEditModal}
        handleCloseEditModal={handleCloseEditModal}
        editHandleSubmit={editHandleSubmit}
        editAppointmentSubmit={editAppointmentSubmit}
        editRegister={editRegister}
        doctorId={doctorId}
        editErrors={editErrors}
        roleType={roleType}
        facilityDoctorList={facilityDoctorList}
      />
      {currentPatientData.length > 0 && (
        <ConsentModal
          isOpen={isModalOpen}
          getPatientDataConsent={getPatientDataConsent}
          patientData={currentPatientData[0]}
          onSubmitClose={closeOnSubmit}
          onRequestClose={closeModal}
        />
      )}

      <CareContextModal
        isOpen={isContextModalOpen}
        handleClose={handleContextModalClose}
        abhaId={abhaId}
        patId={selectedPatientforModal}
      />
      <UploadFileModal
        isOpen={isUploadModalOpen}
        handleClose={handleUploadtModalClose}
        abhaId={abhaId}
        patientId={selectedPatientforModal}
      />
    </ThemeProvider>
  );
}
export default Appointments;
